<template>
  <div>
    <div v-if="!homePage" class="gallery" id="container">
      <div class="element">
        <div class="frame">
          <div class="mat">
            <div class="art">
              <p class="title">{{ name }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="element" v-for="(resource, index) in resources" :key="index">
        <div class="frame">
          <div class="mat">
            <div class="art">
              <template v-if="isImage(resource.url)">
                <img class="img" height="500" :src="resource.url" loading="lazy" />
              </template>
              <template v-else-if="isVideo(resource.url)">
                <video class="video" controls>
                  <source :src="resource.url" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
              </template>
              <template v-else-if="isAudio(resource.url)">
                <audio class="audio" controls>
                  <source :src="resource.url" type="audio/mpeg">
                  Your browser does not support the audio element.
                </audio>
              </template>
              <template v-else-if="isPDF(resource.url)">
                <embed class="pdf" :src="resource.url" type="application/pdf" width="500" height="600" />
              </template>
            </div>
          </div>
        </div>

        <div v-if="resource.description && resource.description !== 'undefined'" class="description" @click="showCartel(index)">
          <p :id="'description' + index" class="description-text">
            {{ resource.description }}
          </p>
        </div>
        <div :class="'modalClose modal' + index">
          <h5>Description</h5>
          <p>
            {{ resource.description }}
          </p>
        </div>
      </div>

      <div class="element">
        <div class="frame">
          <div class="mat">
            <div class="art">
              <div class="footer">
                <div class="marquee-rtl">
                  <div>Université de Corse</div>
                </div>
                <div class="credits">
                  <span>Mentions Legales</span>
                  <br />
                  <span>Fattu in Corsica</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-container" v-else>
      <component :is="dynamicComponent" :homeImage="homeImage" :exhibitIdProps="exhibitId" @exit="exitHomePage"></component>
    </div>
  </div>
</template>
<script setup>
import { ref, onBeforeMount, defineProps } from 'vue';
import axios from 'axios';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Modele_2 from "../../components/Models/Modele_2.vue";
import Modele_3 from "../../components/Models/Modele_3.vue";
import Modele_1 from "../../components/Models/Modele_1.vue";
import Modele_4 from "../../components/Models/Modele_4.vue";
import Modele_5 from "../../components/Models/Modele_5.vue";
import Modele_6 from "../../components/Models/Modele_6.vue";
import Modele_7 from "../../components/Models/Modele_7.vue";

gsap.registerPlugin(ScrollTrigger);

const props = defineProps({
  exhibitId: String,
  homePageProps: Boolean
})
const resources = ref([]);
const name = ref('');
const userName = ref('');
const homeImage = ref({});
const homePage = ref(props.homePageProps == false && props.exhibitId ? false : true);
const selectedTemplate = ref('');
//const cartel = ref(false);
const route = useRoute();
const resourcesName = ref([])
const id = ref(props.exhibitId ?? route.params.id);

const modeleComponents = {
  Modele_2,
  Modele_3,
  Modele_4,
  Modele_5,
  Modele_6,
  Modele_7,
  Modele_1
};

const dynamicComponent = computed(() => {
  return modeleComponents[selectedTemplate.value] || null;
});

onBeforeMount(async () => {
  id.value = props.exhibitId ?? route.params.id;
  await getHomeImage();
  await getResources();
  await getExhibitName();
  await getUserName();
  await getModel();
});



function extractFileNameFromUrl(url) {
    const urlParts = url.split('?')[0]; // Séparer l'URL des paramètres de requête
    const segments = urlParts.split('/'); // Diviser l'URL en segments
    return segments.pop(); // Récupérer le dernier segment qui devrait être le nom du fichier
}

const isImage = (url) => {
    const fileName = extractFileNameFromUrl(url);
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(fileName);
};

const isVideo = (url) => {
    const fileName = extractFileNameFromUrl(url);
    return /\.(mp4|mov|avi)$/i.test(fileName);
};

const isAudio = (url) => {
    const fileName = extractFileNameFromUrl(url);
    return /\.(mp3|wav)$/i.test(fileName);
};

const isPDF = (url) => {
    const fileName = extractFileNameFromUrl(url);
    return /\.pdf$/i.test(fileName);
};


const getHomeImage = async () => {
  try {
    let response = await axios.get(`${process.env.VUE_APP_BASEURL}/exhibit_home/${id.value}`);
    homeImage.value = response.data[0];
  } catch (error) {
    console.error('Error fetching home image:', error);
  }
};

const getResources = async () => {
  let exhibitId = id.value;

  try {
    // Obtenir les ressources de l'exposition
    let resourcesUrl = `${process.env.VUE_APP_BASEURL}/resources`;
    let response = await axios.post(resourcesUrl, { exhibitId });
    let allResources = response.data;

    // Obtenir les resource_id de gallery_resource
    let galleryUrl = `${process.env.VUE_APP_BASEURL}/galleryResources/${exhibitId}`;
    let galleryResponse = await axios.get(galleryUrl);
    let galleryResourceIds = galleryResponse.data.map(res => res.resource_id);

    // Filtrer les ressources pour ne garder que celles présentes dans gallery_resource
    let filteredResources = allResources.filter(resource => galleryResourceIds.includes(resource.id));

    // Traitement asynchrone des ressources filtrées
    resourcesName.value = filteredResources;
    resources.value = [];

    for (let element of filteredResources) {
      let resourceUrl = `${process.env.VUE_APP_BASEURL}/s3Resource/${element.name}`;
      let resourceResponse = await axios.get(resourceUrl);
      let resourceData = {
        url: resourceResponse.data, 
        description: element.description,
        title: element.title,
      };
      resources.value.push(resourceData);
    }
  } catch (error) {
    console.error("Error fetching resources:", error);
  }
};



const getExhibitName = async () => {
  try {
    let response = await axios.get(`${process.env.VUE_APP_BASEURL}/exhibit/${id.value}`);
    name.value = response.data.exhibit_name;
  } catch (error) {
    console.error('Error fetching exhibit name:', error);
  }
};

const getUserName = async () => {
  try {
    let response = await axios.get(`${process.env.VUE_APP_BASEURL}/user/${id.value}`);
    userName.value = response.data.organisation;
  } catch (error) {
    console.error('Error fetching user name:', error);
  }
};

const getModel = async () => {
  try {
    let response = await axios.get(`${process.env.VUE_APP_BASEURL}/model/${id.value}`);
    if (response.data.length > 0) {
      selectedTemplate.value = response.data[0].model.replace(/è/g, 'e').replace(/\s+/g, '_');
    }
  } catch (error) {
    console.error('Error fetching model:', error);
  }
};

const showCartel = (index) => {
  if (
    document
      .querySelector(`.modal${index}`)
      .className.includes("modalClose")
  ) {
    document.querySelector(`.modal${index}`).classList.remove("modalClose");
    document.querySelector(`.modal${index}`).classList.add("modalOpen");
  } else {
    document.querySelector(`.modal${index}`).classList.remove("modalOpen");

    document.querySelector(`.modal${index}`).classList.add("modalClose");
  }
}

const exitHomePage = () => {
  homePage.value = false;
  setTimeout(() => {
    startAnimation();
  }, 2000);
};

const startAnimation = () => {
  var tl = gsap.timeline();

  let container = document.getElementById("container");

  tl.to(container, {
    x: () =>
      -(container.scrollWidth - document.documentElement.clientWidth) +
      "px",
    ease: "none",
    scrollTrigger: {
      trigger: container,
      invalidateOnRefresh: true,
      pin: true,
      scrub: 1,
      end: () => "+=" + (container.offsetWidth + 50),
    },
  });
};

</script>



<style scoped>
body,
html {
  overscroll-behavior: none;
  overflow-y: hidden !important;
  top: 0px !important;
}

.footer {
  text-align: center;
}

.frame {
  position: relative;
  padding-bottom: 82.5%;
  background: black;
  box-shadow: 0 10px 7px -5px rgba(0, 0, 0, 0.3);
}

.mat {
  position: absolute;
  background: white;
  top: 3.0303%;
  bottom: 3.0303%;
  left: 2.5%;
  right: 2.5%;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5) inset;
}

.modalClose {
  display: none;
}

.modalOpen {
  display: inline;
  position: relative;
  bottom: 500px;
  background-color: white;
  display: block;
  padding: 20px;
  width: 100%;
}

.art {
  position: absolute;
  top: 3.129%;
  bottom: 3.129%;
  left: 1.158%;
  right: 1.158%;
}

img {
  height: 100%;
  object-fit: contain;
  width: 100%;
}

video {
  height: 100%;
  object-fit: contain;
  width: 100%;
}

.art:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5) inset;
}

.element {
  width: 40%;
  margin-left: 10%;
  margin-right: 10%;
  height: 100%;
  margin-top: 5%;
}

.gallery {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  height: 100vh;
}

.header {
  position: fixed;
  top: 0;
}

.footerBlack {
  background-color: black;
  height: 70px;
}

.description {
  height: 100px;
  width: 300px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 1em;
  line-height: 15px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  margin-top: 1%;
  padding: 2px;
  cursor: zoom-in;
}
.userName, .title {
  font-size: 1.5rem;
  color: #333; /* Couleur du texte */
  padding: 0.5rem; /* Espacement autour du texte */
  margin: 0; /* Ajustez les marges si nécessaire */
  text-align: center; /* Alignement du texte */
  font-weight: bold; /* Mettre le texte en gras */
  text-transform: uppercase; /* Mettre le texte en majuscules */
  letter-spacing: 0.05em; /* Espacement entre les lettres */
  transition: all 0.3s ease; /* Animation douce lors des changements */
}
</style>